module.exports = __webpack_public_path__ + "media/images/2048x1536-001-6bffe49fbdca75545674f5a67cd6fdb2.png";